// Étanchéité des échecs d'accès aux DONNÉES (PostgREST, Storage, RPC) —
// pendant de `invoke-error.ts`, qui fait le même travail pour les Edge
// Functions.
//
// Le problème est plus simple que celui des edges, et plus répandu : un
// `error.message` PostgREST est un message de moteur de base de données, écrit
// pour un développeur. Il est en anglais, il nomme des tables et des
// contraintes, et il ne dit jamais quoi faire :
//
//   new row violates row-level security policy for table "persons"
//   update or delete on table "persons" violates foreign key constraint …
//   permission denied for function merge_persons
//   JWT expired
//
// Le premier a été affiché tel quel à l'usagère, à l'écran Personnes, après un
// simple « Créer » (observé en production le 25 août). Un préfixe français
// devant (« Création non enregistrée : … ») ne rachète rien : la moitié de la
// phrase reste en anglais (DS §6.13, l'anti-patron).
//
// La règle du DS §6.13 s'applique ICI, au point de passage : chaque helper de
// `lib/` journalise le motif technique et rend UNE DE NOS PHRASES. Les écrans
// se contentent d'afficher `r.error` — sans y remettre de préfixe, qui
// dédoublerait la phrase.
//
// Ce que ce module n'est pas : une traduction par cas. `friendlyNetworkError`
// (`lib/captures/sync-capture.ts`) reconnaît des motifs et RETOMBE SUR LE TEXTE
// BRUT quand aucun ne correspond — une traduction par cas n'est pas une
// étanchéité. Ici il n'y a aucune liste : le motif ne ressort jamais, connu ou
// pas.

export interface DbLikeError {
  message: string;
}

/**
 * Journalise un motif technique d'accès aux données. `scope` situe l'appel
 * (`persons.create`, `captures.fetch`) et n'est jamais affiché.
 *
 * À utiliser seul quand l'écran n'affiche pas le motif de toute façon (il a sa
 * propre phrase, ou n'exploite que le booléen) : sans ça, l'échec ne laisse
 * aucune trace nulle part.
 */
export function logDbError(scope: string, detail: string): void {
  console.error(`[${scope}] accès aux données refusé :`, detail);
}

/**
 * Journalise le motif technique et rend la phrase à afficher.
 *
 * @param scope   d'où vient l'appel — préfixe de journal, jamais affiché.
 * @param error   l'erreur PostgREST/Storage telle que rendue par la librairie.
 * @param generic notre phrase, propre à l'action tentée (cause puis geste).
 */
export function dbErrorMessage(scope: string, error: DbLikeError, generic: string): string {
  logDbError(scope, error.message);
  return generic;
}
